<template>
<box-view class="order-history" title="Lịch sử đơn hàng" @close="$router.back()">

    <!-- FILTER BAR -->
    <div class="container card mb-2 p-2">
        <div class="row g-2 align-items-center">

            <div class="col-md-3">
                <input v-model="searchQuery" type="text" class="form-control form-control-sm" placeholder="Tìm tên khách / SĐT / mã đơn" />
            </div>

            <div class="col-md-2">
                <input v-model="fromDate" type="date" class="form-control form-control-sm" />
            </div>

            <div class="col-md-2">
                <input v-model="toDate" type="date" class="form-control form-control-sm" />
            </div>

            <div class="col-md-auto ms-auto">
                <button class="btn btn-sm btn-outline-secondary" @click="$router.push({ name: 'returnhistory' })">
                    <i class="fas fa-history"></i> Lịch sử trả hàng
                </button>
            </div>
        </div>

        <!-- COMPACT SUMMARY -->
        <div class="mt-2 pt-2 border-top d-flex flex-wrap justify-content-center justify-content-md-start">
            <div class="summary-box mr-4 me-4">
                <span class="text-muted small">Tổng SL:</span>
                <span class="fw-bold ms-1 text-primary">{{ totalFilteredQty | formatNumber }}</span>
            </div>
            <div class="summary-box mr-4 me-4">
                <span class="text-muted small">Doanh số:</span>
                <span class="fw-bold ms-1 text-success">{{ totalFilteredAmount | formatNumber }}₫</span>
            </div>
            <div class="summary-box">
                <span class="text-muted small">Số đơn:</span>
                <span class="fw-bold ms-1 text-dark">{{ filteredOrders.length | formatNumber }}</span>
            </div>
        </div>
    </div>

    <!-- TABLE LIST -->
    <div class="table-responsive container">
        <table class="table table-sm table-bordered align-middle">
            <thead class="table-info">
                <tr>
                    <th>#</th>
                    <th>Khách hàng</th>
                    <th>Tổng SL</th>
                    <th>Tổng bill</th>
                    <th>Tổng thu</th>
                    <th>Người tạo</th>
                    <th>Thời gian</th>
                    <th width="40"></th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(order, index) in paginatedOrders" :key="order.id">
                    <td>
                        <div>{{ (currentPage - 1) * pageSize + index + 1 }}</div>
                        <div v-if="hasReturn(order)" class="mt-1">
                            <span class="badge bg-warning text-dark x-small px-1" title="Đã có trả hàng"><i class="fas fa-undo"></i> Hoàn/Trả</span>
                        </div>
                    </td>
                    <td>
                        <div class="fw-bold">{{ order.customer.name || 'Khách lẻ' }}</div>
                        <small class="text-muted">{{ order.customer.phone }}</small>
                    </td>
                    <td class="text-center fw-bold">{{ getOrderTotalQty(order) | formatNumber }}</td>

                    <td>{{ (order.totalBill || order.totalPay || 0) | formatNumber }}</td>
                    <td class="text-danger fw-bold">
                        <div>{{ (order.paid || 0) | formatNumber }}</div>
                        <div v-show="(order.cashAmount || 0) > 0 || (order.transferAmount || 0) > 0" class="small text-muted mt-1" style="font-size: 0.75em; font-weight: normal;">
                            <div v-if="(order.cashAmount || 0) > 0">💵 {{ order.cashAmount | formatNumber }}</div>
                            <div v-if="(order.transferAmount || 0) > 0">🏦 {{ order.transferAmount | formatNumber }}</div>
                        </div>
                    </td>

                    <td>{{ order.user.name }}</td>
                    <td>{{ formatTime(order.createdAt) }}</td>

                    <td class="text-center">
                        <button class="btn btn-sm btn-primary" @click="openDetail(order)">
                            <i class="fas fa-eye"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- PAGINATION -->
    <nav v-if="totalPages > 1" class="mt-2 container">
        <ul class="pagination pagination-sm justify-content-center flex-wrap">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(1)" title="Trang đầu">««</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage - 1)">«</a>
            </li>
            <li v-for="(page, idx) in visiblePages" :key="'p'+idx"
                class="page-item"
                :class="{ active: page === currentPage, disabled: page === '...' }">
                <a class="page-link" href="#"
                   @click.prevent="page !== '...' && goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage + 1)">»</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)" title="Trang cuối">»»</a>
            </li>
        </ul>
        <div class="text-center text-muted small">Trang {{ currentPage }} / {{ totalPages }}</div>
    </nav>

    <!-- DETAIL POPUP -->
    <div v-if="showDetail" class="modal-backdrop-custom">
        <div class="modal-custom">

            <div class="modal-header bg-primary text-white">
                <h6 class="mb-0">CHI TIẾT ĐƠN HÀNG</h6>
                <div>
                    <button class="btn btn-sm btn-info me-1" @click="printOrder(selectedOrder)">
                        <i class="fas fa-print"></i> In Bill
                    </button>
                    <button class="btn btn-sm btn-warning me-1" @click="openReturn()">
                        <i class="fas fa-undo"></i> Trả hàng
                    </button>
                    <button class="btn btn-sm btn-danger" @click="showDetail = false">
                        ✕
                    </button>
                </div>
            </div>

            <div class="modal-body" v-if="selectedOrder && selectedOrder.id">

                <!-- ORDER INFO -->
                <div class="info-box mb-3">
                    <div class="d-flex mb-2 align-items-center">
                        ▶ <b class="mx-1">Tên đơn:</b> {{ selectedOrder.id }}
                        <span v-if="hasReturn(selectedOrder)" class="badge bg-warning text-dark ms-2"><i class="fas fa-undo"></i> Đã có đơn hoàn/trả</span>
                    </div>
                    <div class="d-flex mb-2">▶ <b class="mx-1">Khách hàng:</b> {{ selectedOrder.customer?.name }}</div>
                    <div class="d-flex mb-2">▶ <b class="mx-1">Điện thoại:</b> {{ selectedOrder.customer?.phone }}</div>
                    <div class="d-flex mb-2">▶ <b class="mx-1">Địa chỉ:</b> {{ selectedOrder.customer?.address }}</div>
                    <div class="d-flex mb-2">▶ <b class="mx-1">Người tạo:</b> {{ selectedOrder.user?.name }}</div>
                    <div class="d-flex mb-2">▶ <b class="mx-1">Tạo lúc:</b> {{ formatTime(selectedOrder.createdAt) }}</div>
                    <div class="d-flex">▶ <b class="mx-1">Ghi chú:</b> {{ selectedOrder.customer?.note || '—' }}</div>
                </div>

                <!-- PRODUCT TABLE -->
                <table class="table table-sm table-bordered">
                    <thead class="table-info">
                        <tr>
                            <th>#</th>
                            <th>Tên sản phẩm</th>
                            <th>Giá vốn</th>
                            <th>Giá bán</th>
                            <th>SL</th>
                            <th>Thành tiền</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, i) in selectedOrder.cart" :key="i">
                            <td>{{ i + 1 }}</td>
                            <td>{{ item.product.name }}</td>
                            <td>{{ (item.cost || 0) | formatNumber }}</td>
                            <td>{{ (item.price || 0) | formatNumber }}</td>
                            <td>{{ item.quantity | formatNumber }}</td>
                            <td class="fw-bold">
                                {{ ((item.price || item.product?.price || 0) * item.quantity) | formatNumber }}
                            </td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td colspan="4" class="text-end fw-bold">
                                Tổng số lượng
                            </td>
                            <td class="fw-bold">
                                {{ getOrderTotalQty(selectedOrder) | formatNumber }}
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="5" class="text-end fw-bold">
                                Khách đã trả
                            </td>
                            <td class="text-danger fw-bold">
                                <div>{{ (selectedOrder.paid || 0) | formatNumber }}</div>
                                <div v-show="(selectedOrder.cashAmount || 0) > 0 || (selectedOrder.transferAmount || 0) > 0" class="small text-muted mt-1" style="font-size: 0.8em; font-weight: normal; text-align: left;">
                                    <div v-if="(selectedOrder.cashAmount || 0) > 0">💵 {{ selectedOrder.cashAmount | formatNumber }}</div>
                                    <div v-if="(selectedOrder.transferAmount || 0) > 0">🏦 {{ selectedOrder.transferAmount | formatNumber }}</div>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>

            </div>
        </div>
    </div>
    <!-- trả hàng -->
    <div v-if="showReturn" class="modal-backdrop-custom">
        <div class="modal-custom">

            <div class="modal-header bg-warning">
                <h6 class="mb-0">TRẢ HÀNG - {{ selectedOrder.id }}</h6>
                <button class="btn btn-sm btn-danger" @click="showReturn=false">✕</button>
            </div>

            <div class="modal-body">

                <table class="table table-sm table-bordered">
                    <thead class="table-info">
                        <tr>
                            <th>#</th>
                            <th>Sản phẩm</th>
                            <th>SL đã mua</th>
                            <th>SL trả</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item,i) in returnCart" :key="i">
                            <td>{{ i+1 }}</td>
                            <td>{{ item.product.name }}</td>
                            <td>{{ item.quantity | formatNumber }}</td>
                            <td width="120">
                                <money-input class="form-control form-control-sm" v-model="item.returnQty" :max="item.quantity" />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="mt-2">
                    <label class="fw-bold">Lý do trả hàng</label>
                    <textarea v-model="returnNote" class="form-control form-control-sm"></textarea>
                </div>

            </div>

            <div class="modal-footer">
                <button class="btn btn-secondary btn-sm" @click="showReturn=false">
                    Hủy
                </button>
                <button class="btn btn-danger btn-sm" @click="confirmReturn">
                    Xác nhận trả hàng
                </button>
            </div>

        </div>
    </div>

    <!-- CHỌN PHƯƠNG THỨC HOÀN TIỀN -->
    <div v-if="showRefundModeSelector" class="modal-backdrop-custom" style="z-index: 10000;">
        <div class="modal-custom" style="max-width: 400px;">
            <div class="modal-header bg-primary text-white">
                <h6 class="mb-0">PHƯƠNG THỨC HOÀN TIỀN</h6>
            </div>
            <div class="modal-body text-center py-4">
                <p class="mb-4">Bạn muốn xử lý số tiền hoàn trả <b>{{ pendingReturnOrder?.totalRefund | formatNumber }}₫</b> này như thế nào?</p>
                <div class="d-grid gap-2">
                    <button class="btn btn-outline-primary mb-2" @click="completeReturn('to_deposit')">
                        <i class="fas fa-wallet mr-2"></i> Chuyển vào tiền cọc (Không hoàn tiền)
                    </button>
                    <button class="btn btn-outline-success" @click="completeReturn('cash')">
                        <i class="fas fa-money-bill-wave mr-2"></i> Hoàn tiền mặt / Chuyển khoản (Như cũ)
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary btn-sm" @click="showRefundModeSelector = false">Hủy</button>
            </div>
        </div>
    </div>




</box-view>
</template>

<script>
export default {
    props: {
        orders: {
            type: Array,
            default: () => []
        },
        returnOrders: {
            type: Array,
            default: () => []
        },
        user: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            searchQuery: '',
            showCartPopup: false,
            showOrderDialog: false,
            showMenu: false,
            discount: 0,
            paid: 0,
            showReturn: false,
            returnCart: [],
            returnNote: '',
            fromDate: '',
            toDate: '',
            showDetail: false,
            selectedOrder: {},
            showRefundModeSelector: false,
            pendingReturnOrder: null,
            
            //phân trang
            currentPage: 1,
            pageSize: 30
        };
    },

    computed: {
        filteredOrders() {
            // TODO: API INTEGRATION - Move filtering to backend
            // GET /api/orders?search={searchQuery}&fromDate={fromDate}&toDate={toDate}
            return this.orders.filter(o => {
                const keyword = this.searchQuery.toLowerCase()

                const matchText =
                    String(o.id || '').toLowerCase().includes(keyword) ||
                    String(o.customer?.name || '').toLowerCase().includes(keyword) ||
                    String(o.customer?.phone || '').includes(keyword)

                const orderDate = new Date(o.createdAt)

                let from = null
                let to = null

                if (this.fromDate) {
                    from = new Date(this.fromDate)
                    from.setHours(0, 0, 0, 0)
                }

                if (this.toDate) {
                    to = new Date(this.toDate)
                    to.setHours(23, 59, 59, 999)
                }

                const matchDate =
                    (!from || orderDate >= from) &&
                    (!to || orderDate <= to)

                return matchText && matchDate
            })
        },
        totalPages() {
             // TODO: API INTEGRATION - Use 'total' from API response
            return Math.ceil(this.filteredOrders.length / this.pageSize)
        },

        visiblePages() {
            const total = this.totalPages
            const current = this.currentPage
            const delta = 2 // số trang hiển thị mỗi bên trang hiện tại
            const pages = []

            if (total <= 7) {
                // Ít trang thì hiển thị hết
                for (let i = 1; i <= total; i++) pages.push(i)
                return pages
            }

            // Luôn hiển thị trang 1
            pages.push(1)

            // Tính vùng lân cận
            const rangeStart = Math.max(2, current - delta)
            const rangeEnd = Math.min(total - 1, current + delta)

            // Dấu ... trước vùng lân cận
            if (rangeStart > 2) pages.push('...')

            // Các trang lân cận
            for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i)

            // Dấu ... sau vùng lân cận
            if (rangeEnd < total - 1) pages.push('...')

            // Luôn hiển thị trang cuối
            pages.push(total)

            return pages
        },

        paginatedOrders() {
            // TODO: API INTEGRATION - Use data directly from API (already paginated)
            // GET /api/orders?page={currentPage}&limit={pageSize}
            const start = (this.currentPage - 1) * this.pageSize
            const end = start + this.pageSize
            return this.filteredOrders.slice(start, end)
        },
        totalFilteredQty() {
            return this.filteredOrders.reduce((sum, order) => sum + this.getOrderTotalQty(order), 0);
        },
        totalFilteredAmount() {
            return this.filteredOrders.reduce((sum, order) => sum + parseFloat(order.totalBill || order.totalPay || 0), 0);
        }
    },

    methods: {
        goToPage(page) {
            if (page < 1) page = 1
            if (page > this.totalPages) page = this.totalPages
            this.currentPage = page
        },
        hasReturn(order) {
            if (!this.returnOrders || !this.returnOrders.length) return false;
            return this.returnOrders.some(ro => {
                const isMatchId = ro.orderId === order.id;
                const isMatchOriginalId = order.original_id && ro.originalOrder && ro.originalOrder.id === order.original_id;
                return isMatchId || isMatchOriginalId;
            });
        },
        formatTime(time) {
            return new Date(time).toLocaleString();
        },
        getOrderTotalQty(order) {
            if (!order || !order.cart) return 0;
            return order.cart.reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);
        },
        openDetail(order) {
            this.selectedOrder = order;
            this.showDetail = true;
        },
        printOrder(order) {
            // For historical orders, we need to pass the debt calculated at the time of the order
            const historicalDebt = order.finalTotalDebt !== undefined ? order.finalTotalDebt : (order.customer?.debtAmount || 0);
            const orderWithHistoryDebt = {
                ...order,
                finalTotalDebt: historicalDebt
            };
            this.$emit('print-bill', { order: orderWithHistoryDebt, printType: 'invoice' });
        },
        close() {
            this.$router.back();
        },
        openReturn() {
            this.showReturn = true
            this.returnNote = ''

            // clone cart để nhập SL trả
            this.returnCart = this.selectedOrder.cart.map(i => ({
                ...i,
                returnQty: 0
            }))
        },

        confirmReturn() {
            const returnedItems = this.returnCart.filter(i => i.returnQty > 0)

            if (!returnedItems.length) {
                alert('Chưa chọn sản phẩm trả')
                return
            }

            // Calculate total refund
            const totalRefund = returnedItems.reduce((sum, item) => {
                return sum + (Number(item.price || 0) * Number(item.returnQty || 0));
            }, 0);

            this.pendingReturnOrder = {
                // Use original_id (int) for cleaner ID and correct linking
                id: 'TH-' + (this.selectedOrder.original_id || this.selectedOrder.id) + '-' + Date.now(),
                // Backend expects Integer ID for the link
                originOrderId: this.selectedOrder.original_id, 
                createdAt: new Date().toISOString(),
                items: returnedItems,
                note: this.returnNote,
                user: this.user,
                customer: this.selectedOrder.customer,
                totalRefund: totalRefund
            }

            this.showRefundModeSelector = true;
        },

        completeReturn(mode) {
            if (!this.pendingReturnOrder) return;
            
            const finalOrder = {
                ...this.pendingReturnOrder,
                refundMode: mode
            };

            this.$emit('return-order', finalOrder);
            
            this.showRefundModeSelector = false;
            this.showReturn = false;
            this.showDetail = false;
            this.pendingReturnOrder = null;
        }
    },
    watch: {
        searchQuery() {
            this.currentPage = 1
        }
    }

};
</script>

<style scoped>
.x-small {
    font-size: 0.65rem;
}
.bg-primary-soft {
    background-color: rgba(13, 110, 253, 0.1);
}
.bg-success-soft {
    background-color: rgba(25, 135, 84, 0.1);
}
.bg-info-soft {
    background-color: rgba(13, 202, 240, 0.1);
}
.summary-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 0.9rem;
}
.summary-item {
    transition: transform 0.2s;
}
.summary-item:hover {
    transform: translateY(-2px);
}
.modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    padding: 10px;
}
.modal-custom {
    background: white;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.modal-header {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modal-body {
    padding: 15px;
    overflow-y: auto;
}
.info-box {
    background: #f8f9fa;
    padding: 12px;
    border-radius: 6px;
    font-size: 0.85rem;
}
.summary-box {
    padding: 4px 12px;
    border-radius: 4px;
    background: #f8f9fa;
    border: 1px solid #eee;
}
</style>
